import React from "react";
import InfiniteScroll from "react-infinite-scroller";

import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import Filter from "./Filter";
import Search from "./Search";
import Sort from "./Sort";
import StoreCard from "./StoreCard";

import {
    selectStores,
    selectCandidateStore,
    setCandidateStore,
    clearCandidateStore,
    clearCandidateComparator
} from "modules/customer/insights/portfolioNew/filters/filtersSlice";
import { Store } from "modules/customer/insights/portfolioNew/store";
import { useAppDispatch, useAppSelector } from "store";

const NUMBER_OF_VISIBLE_STORES_INCREMENT = 15;

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark
    }
}))(Card);

const Stores: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const stores = useAppSelector(selectStores);
    const candidateStore = useAppSelector(selectCandidateStore);
    const [numberOfVisibleStores, setNumberOfVisibleStores] = React.useState<number>(0);
    const storesLabel = `${stores.length} ${stores.length === 1 ? "store" : "stores"}`;

    const visibleStores = React.useMemo(() => {
        return stores.slice(0, numberOfVisibleStores);
    }, [stores, numberOfVisibleStores]);

    const handleSelect = (store: Store) => {
        dispatch(setCandidateStore(store));
        dispatch(clearCandidateComparator());
    };

    const handleDeselect = () => {
        dispatch(clearCandidateStore());
        dispatch(clearCandidateComparator());
    };

    const handleLoadMore = React.useCallback(() => {
        setNumberOfVisibleStores(previousNumberOfVisibleStores => previousNumberOfVisibleStores + NUMBER_OF_VISIBLE_STORES_INCREMENT);
    }, [setNumberOfVisibleStores]);

    React.useEffect(() => {
        setNumberOfVisibleStores(NUMBER_OF_VISIBLE_STORES_INCREMENT);
    }, [stores]);

    return (
        <InfiniteScroll
            initialLoad={false}
            loadMore={handleLoadMore}
            hasMore={numberOfVisibleStores <= stores.length}
            useWindow={false}
        >
            <Box marginBottom={4}>
                <Box position="sticky" top={0} bgcolor={theme.palette.background.paper} zIndex={theme.zIndex.drawer}>
                    <Search />
                    <Box display="flex" alignItems="center" paddingTop={2} paddingBottom={0.5}>
                        <Typography variant="body1" component="div">
                            &nbsp;&nbsp;{storesLabel}
                        </Typography>
                        <Spacer />
                        <Filter />
                        &nbsp;&nbsp;
                        <Sort />
                    </Box>
                </Box>
                {visibleStores.length > 0 && (
                    <StyledCard elevation={0}>
                        <CardContent>
                            <Grid container spacing={2}>
                                {visibleStores.map(store =>
                                    <Grid key={store.id} item xs={4}>
                                        <StoreCard
                                            store={store}
                                            selected={candidateStore?.id === store.id}
                                            onSelect={handleSelect}
                                            onDeselect={handleDeselect}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                    </StyledCard>
                )}
            </Box>
        </InfiniteScroll>
    );
};

export default Stores;
